// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../components/Form.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Tools from "../Tools.bs.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ProfileLabel from "./ProfileLabel.bs.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import AddressesJson from "../assets/addresses.json";

var addresses = AddressesJson;

function getValue(x) {
  if (x.TAG === /* Ok */0) {
    return Belt_Option.getWithDefault(x._0, "");
  } else {
    return x._0;
  }
}

var provincesToDistricts = {
  contents: undefined
};

var provinces = addresses.map(function (x) {
      var name = x[0];
      var buff = {
        contents: undefined
      };
      var r = {
        value: name,
        label: name
      };
      Js_dict.entries(x[1]).forEach(function (d) {
            var subs = {
              contents: undefined
            };
            Js_dict.entries(d[1]).forEach(function (s) {
                  subs.contents = Belt_MapString.set(subs.contents, s[0], s[1]);
                  
                });
            var subs$1 = subs.contents;
            buff.contents = Belt_MapString.set(buff.contents, d[0], subs$1);
            
          });
      var buff$1 = buff.contents;
      provincesToDistricts.contents = Belt_MapString.set(provincesToDistricts.contents, name, buff$1);
      return r;
    });

function empty(param) {
  return {
          province: undefined,
          district: undefined,
          sub_district: undefined,
          postcode: {
            TAG: /* Ok */0,
            _0: undefined
          },
          detail: undefined
        };
}

var placeholder_must_choose = ProfileLabel.placeholder_text.must_choose;

var placeholder_must_input = ProfileLabel.placeholder_text.must_input;

var placeholder_option_input = ProfileLabel.placeholder_text.option_input;

var err_postcode = ProfileLabel.err_text.postcode;

function checkPostcode(x) {
  var cond = /^\d{5}$/;
  if (cond.test(x)) {
    return {
            TAG: /* Ok */0,
            _0: x
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: x
          };
  }
}

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* ChangeState */0 :
        return action._0;
    case /* ChangeProvince */1 :
        return {
                province: action._0,
                district: state.district,
                sub_district: state.sub_district,
                postcode: state.postcode,
                detail: state.detail
              };
    case /* ChangeDistrict */2 :
        return {
                province: state.province,
                district: action._0,
                sub_district: state.sub_district,
                postcode: state.postcode,
                detail: state.detail
              };
    case /* ChangeSubDistrict */3 :
        return {
                province: state.province,
                district: state.district,
                sub_district: action._0,
                postcode: state.postcode,
                detail: state.detail
              };
    case /* ChangePostcode */4 :
        return {
                province: state.province,
                district: state.district,
                sub_district: state.sub_district,
                postcode: Belt_Result.map(checkPostcode(action._0), (function (x) {
                        return x;
                      })),
                detail: state.detail
              };
    case /* ChangeDetail */5 :
        return {
                province: state.province,
                district: state.district,
                sub_district: state.sub_district,
                postcode: state.postcode,
                detail: action._0
              };
    
  }
}

function mapToSelectOptionT(d) {
  return Form.Select.dataOptionFromArray(Belt_MapString.keysToArray(d));
}

function checkAddress(addr) {
  var r = Belt_Result.flatMap(Belt_Result.flatMap(Belt_Result.flatMap(Tools.toOk(addr.province), (function (param) {
                  return Tools.toOk(addr.district);
                })), (function (param) {
              return Tools.toOk(addr.sub_district);
            })), (function (param) {
          return Tools.okNotEmpty(addr.postcode);
        }));
  if (r.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: addr
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: addr
          };
  }
}

function fromJson(data) {
  return checkAddress({
              province: Belt_Option.flatMap(Js_dict.get(data, "province"), Js_json.decodeString),
              district: Belt_Option.flatMap(Js_dict.get(data, "district"), Js_json.decodeString),
              sub_district: Belt_Option.flatMap(Js_dict.get(data, "sub_district"), Js_json.decodeString),
              postcode: {
                TAG: /* Ok */0,
                _0: Belt_Option.flatMap(Js_dict.get(data, "postcode"), Js_json.decodeString)
              },
              detail: Belt_Option.flatMap(Js_dict.get(data, "detail"), Js_json.decodeString)
            });
}

function toJson(data) {
  return Js_dict.fromList(Belt_List.flatten({
                  hd: {
                    hd: [
                      "province",
                      Belt_Option.getWithDefault(data.province, "")
                    ],
                    tl: /* [] */0
                  },
                  tl: {
                    hd: {
                      hd: [
                        "district",
                        Belt_Option.getWithDefault(data.district, "")
                      ],
                      tl: /* [] */0
                    },
                    tl: {
                      hd: {
                        hd: [
                          "sub_district",
                          Belt_Option.getWithDefault(data.sub_district, "")
                        ],
                        tl: /* [] */0
                      },
                      tl: {
                        hd: {
                          hd: [
                            "postcode",
                            getValue(data.postcode)
                          ],
                          tl: /* [] */0
                        },
                        tl: {
                          hd: {
                            hd: [
                              "detail",
                              Belt_Option.getWithDefault(data.detail, "")
                            ],
                            tl: /* [] */0
                          },
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }));
}

function getPostcode(sub_district, sub_districts) {
  var postcodes = sub_district !== undefined ? Belt_MapString.getWithDefault(sub_districts, sub_district, []) : [];
  if (postcodes.length !== 0) {
    return Belt_Array.get(postcodes, 0);
  }
  
}

function ProfileAddress(Props) {
  var init_address = Props.init_address;
  var onChange = Props.onChange;
  var match = React.useReducer(reducer, init_address);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setDistricts = match$1[1];
  var districts = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setSubDistricts = match$2[1];
  var sub_districts = match$2[0];
  var block_auto_postcode = React.useRef(true);
  React.useEffect((function () {
          if (onChange !== undefined) {
            Curry._1(onChange, checkAddress(state));
          }
          
        }), [state]);
  React.useEffect((function () {
          var x = state.province;
          if (x !== undefined) {
            var x$1 = Belt_MapString.getExn(provincesToDistricts.contents, x);
            Curry._1(setDistricts, (function (param) {
                    var match = Belt_MapString.get(x$1, Belt_Option.getWithDefault(state.district, ""));
                    if (match !== undefined) {
                      
                    } else {
                      Curry._1(dispatch, {
                            TAG: /* ChangeDistrict */2,
                            _0: undefined
                          });
                    }
                    return x$1;
                  }));
          }
          
        }), [state.province]);
  React.useEffect((function () {
          var _district = state.district;
          var data = _district !== undefined ? Belt_MapString.get(districts, _district) : Caml_option.some(undefined);
          if (data !== undefined) {
            var d = Caml_option.valFromOption(data);
            Curry._1(setSubDistricts, (function (param) {
                    var match = Belt_MapString.get(d, Belt_Option.getWithDefault(state.sub_district, "_NOT_FOUND"));
                    if (match !== undefined) {
                      
                    } else {
                      Curry._1(dispatch, {
                            TAG: /* ChangeSubDistrict */3,
                            _0: undefined
                          });
                    }
                    block_auto_postcode.current = false;
                    return d;
                  }));
          } else {
            Curry._1(setSubDistricts, (function (param) {
                    
                  }));
          }
          
        }), [
        state.district,
        districts
      ]);
  React.useEffect((function () {
          if (!block_auto_postcode.current) {
            var p = getPostcode(state.sub_district, sub_districts);
            if (p !== undefined) {
              Curry._1(dispatch, {
                    TAG: /* ChangePostcode */4,
                    _0: p
                  });
            }
            
          }
          
        }), [state.sub_district]);
  return React.createElement(React.Fragment, undefined, React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "จังหวัด"
                    }), React.createElement(Form.SelectWithInitialPlaceholder.make, {
                      placeholder: placeholder_must_choose,
                      data: provinces,
                      value: state.province,
                      onChange: (function (x) {
                          return Curry._1(dispatch, {
                                      TAG: /* ChangeProvince */1,
                                      _0: x
                                    });
                        })
                    })), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "เขต/อำเภอ"
                    }), React.createElement(Form.SelectWithInitialPlaceholder.make, {
                      placeholder: placeholder_must_choose,
                      data: Form.Select.dataOptionFromArray(Belt_MapString.keysToArray(districts)),
                      value: state.district,
                      onChange: (function (x) {
                          return Curry._1(dispatch, {
                                      TAG: /* ChangeDistrict */2,
                                      _0: x
                                    });
                        })
                    })), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "แขวง/ตำบล"
                    }), React.createElement(Form.SelectWithInitialPlaceholder.make, {
                      placeholder: placeholder_must_choose,
                      data: Form.Select.dataOptionFromArray(Belt_MapString.keysToArray(sub_districts)),
                      value: state.sub_district,
                      onChange: (function (x) {
                          return Curry._1(dispatch, {
                                      TAG: /* ChangeSubDistrict */3,
                                      _0: x
                                    });
                        })
                    })), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "รหัสไปรษณีย์"
                    }), React.createElement(Form.InputText.make, {
                      value: getValue(state.postcode),
                      onChange: (function (v) {
                          return Curry._1(dispatch, {
                                      TAG: /* ChangePostcode */4,
                                      _0: v.target.value
                                    });
                        }),
                      placeholder: placeholder_must_input,
                      error: Belt_Result.isError(state.postcode) ? err_postcode : undefined
                    })), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "รายละเอียดที่อยู่ เช่น บ้านเลขที่"
                    }), React.createElement(Form.TextArea.make, {
                      placeholder: placeholder_option_input,
                      value: Belt_Option.getWithDefault(state.detail, ""),
                      onChange: (function (v) {
                          return Curry._1(dispatch, {
                                      TAG: /* ChangeDetail */5,
                                      _0: v.target.value
                                    });
                        }),
                      rows: 3
                    })));
}

var make = ProfileAddress;

export {
  addresses ,
  getValue ,
  provincesToDistricts ,
  provinces ,
  empty ,
  placeholder_must_choose ,
  placeholder_must_input ,
  placeholder_option_input ,
  err_postcode ,
  checkPostcode ,
  reducer ,
  mapToSelectOptionT ,
  checkAddress ,
  fromJson ,
  toJson ,
  getPostcode ,
  make ,
  
}
/* addresses Not a pure module */
